module.exports = __webpack_public_path__ + "static/media/po-prostu-reaguj-kampania.a58c53e5.pdf";